import axios from "axios";

const instance = axios.create({
  baseURL: process.env.VUE_APP_URL_API
});

//instance.defaults.headers.get['Accepts'] = 'application/json';

export default instance;
